import { createSelector } from 'reselect';

import { configSelector } from './config';
import { signedInSelector } from 'shared/app/bundles/user';

// TODO NEXT_GEN_LOYALTY
export const globalNavMainNavLinksSelector = (nextGenLoyaltyEnabled) =>
  createSelector(configSelector, signedInSelector, (config, signedIn) => {
    if (signedIn && nextGenLoyaltyEnabled.enabled) {
      return config?.globalNav?.authMainNavLinks;
    }
    return config?.globalNav?.mainNavLinks;
  });

export const globalNavAccountNavSelector = createSelector(
  configSelector,
  (config) => config?.globalNav?.accountNav
);
